import { ChatServerAsyncActionType } from "../../utils/useChatServerDispatch";
import { ChatMessageRequest } from "../../xapp/ChatServerMessage";

export default function sendMessage(msg: ChatMessageRequest): ChatServerAsyncActionType {
    return chatServer => () => {
        chatServer.sendChatMsgRequest(msg, () => {});
    };
}
